<template>
  <div class="flow-templates modal-content">
    <div class="box">
      <header class="title is-5">Question Flow Generator</header>
      <div class="container flow-templates__container">
        <b-field label="Number of options">
          <b-numberinput
            v-model="numberOfOptions"
            :editable="false"
          ></b-numberinput>
        </b-field>
        <b-field label="Index of currect option">
          <b-select
            v-model="currectAnswer"
            placeholder="select currect option"
            expanded
          >
            <option :value="-1">Don't assign a correct option.</option>
            <option
              v-for="(_, index) in Array(numberOfOptions).fill()"
              :key="index"
              :value="index"
            >
              {{ index + 1 }}
            </option>
          </b-select>
        </b-field>
        <b-field label="Input Display Type">
          <v-select
            :key="inputDisplayType"
            :clearable="false"
            :options="inputDisplayTypes"
            placeholder="Select Input Display Type"
            :reduce="option => option.value"
            :value="inputDisplayType"
            @input="
              fieldChangeHandler({
                target: { name: 'inputDisplayType', value: $event }
              })
            "
          />
        </b-field>
        <b-button
          class="is-fullwidth"
          native-type="submit"
          type="is-primary"
          @click="generateTemplate"
        >
          Generate
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
const FlowTemplateGeneratorModal = {
  data() {
    return {
      numberOfOptions: 4,
      currectAnswer: -1,
      optionsPromptPrefix: 'prompt',
      inputDisplayTypes: [
        {
          label: 'Default',
          value: 'default'
        },
        {
          label: 'Large',
          value: 'large'
        }
      ],
      inputDisplayType: 'default'
    };
  },
  methods: {
    fieldChangeHandler({ target }) {
      this[target.name] = target.value;
      this.triggerOnChange();
    },
    generateTemplate() {
      const template = {
        answers: {},
        prompts: {}
      };

      template.prompts.start = {
        message: '',
        answers: 'choices',
        inputDisplayType: this.inputDisplayType
      };

      template.answers.choices = [];

      Array(this.numberOfOptions)
        .fill()
        .forEach((_, index) => {
          const isCorrect = index === this.currectAnswer;
          const promptKey = isCorrect ? `correct` : `choice${index + 1}`;

          template.answers.choices.push({
            message: `Choice ${index + 1}`,
            score: isCorrect ? 1000 : 0,
            nextKey: `.${promptKey}`
          });

          template.prompts[promptKey] = {
            message: `Replay to choice ${index + 1}`,
            answers: isCorrect ? null : 'choices',
            inputDisplayType: this.inputDisplayType
          };
        });

      this.$emit('input', template);
      this.$emit('close');
    }
  }
};

export default FlowTemplateGeneratorModal;
export function generateTemplate(parent) {
  return new Promise((resolve, reject) => {
    parent.$buefy.modal.open({
      parent,
      component: FlowTemplateGeneratorModal,
      hasModalCard: true,
      events: {
        input: resolve
      },
      onCancel: reject
    });
  });
}
</script>

<style lang="scss" scoped>
.flow-templates {
  width: auto;
  &__container {
    margin: 0;
  }
}
</style>
